module.exports = __webpack_public_path__ + "static/img/partner_org.5d60526e.png";